<template>
  <div class="full-width">
    <h1 class="gt-sm fs-20 q-my-4 q-pa-12 text-bold text-center">
      {{ $t('label.support') }}
    </h1>
    <q-separator />
    <Support class="q-mx-auto q-my-16" />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';

import Support from '~components/support/Support';

import { useAccountStore } from '~stores/account';

const accountStore = useAccountStore();
const route = useRoute();

onMounted(() => {
  if (route.query.inform_review_requested) {
    accountStore.featureInform('carrier_review_requested');
  }
});
</script>

<style lang="scss" scoped>
.support {
  max-width: 600px;
}
</style>
